import { apiRequest } from './apiClient.js'
import websocketService from './websocketService.js'
import { beginIdentityTransition, endIdentityTransition } from './identityTransition.js'
import { unlinkPushDevice, pushDeviceSession } from './pushDeviceSession.js'

async function changeIdentity(path, options) {
  beginIdentityTransition()
  const reconnect = websocketService.shouldReconnect
  websocketService.disconnect()
  try {
    if (pushDeviceSession.device && pushDeviceSession.boundUser) await unlinkPushDevice()
    return await apiRequest(path, { ...options, identityChange: true })
  }
  catch (error) {
    endIdentityTransition()
    if (reconnect) { websocketService.allowReconnect(); websocketService.connect() }
    throw error
  }
}

export const authOperationsService = {
  logout: (options = {}) => changeIdentity('/api/auth/logout', options),
  switchUser: (options = {}) => changeIdentity('/api/auth/switch-user', options),
  switchBack: (options = {}) => changeIdentity('/api/auth/switch-back', options),
}
